import { NgModule } from '@angular/core';

import { NovoClienteCadastroMultiselectModule } from '../../../../../domains/shared/components/novo-cliente-cadastro-multiselect/novo-cliente-cadastro-multiselect.module';
import { NovoClienteSituacaoMultiSelectModule } from '../../../../../domains/shared/components/novo-cliente-situacao-multi-select/novo-cliente-situacao-multi-select.module';
import { NovoPeriodicidadeCompraMultiSelectModule } from '../../../../../domains/shared/components/novo-periodicidade-compra-multi-select/novo-periodicidade-compra-multi-select.module';
import { NovoRepresentanteMultiSelectModule } from '../../../../../domains/shared/components/novo-representante-multi-select/novo-representante-multi-select.module';
import { SharedModule } from '../../../../../shared';
import { NovoClienteFilterAvancadoModule } from './novo-cliente-filter-avancado/novo-cliente-filter-avancado.module';
import { NovoClienteFilterComponent } from './novo-cliente-filter.component';

@NgModule({
  imports: [
    SharedModule,
    NovoClienteSituacaoMultiSelectModule,
    NovoClienteCadastroMultiselectModule,
    NovoRepresentanteMultiSelectModule,
    NovoClienteFilterAvancadoModule,
    NovoPeriodicidadeCompraMultiSelectModule
  ],
  declarations: [NovoClienteFilterComponent],
  exports: [NovoClienteFilterComponent]
})
export class NovoClienteFilterModule {}
